import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
export const onboardingSettingsExperienceMap = {
  NO_EXPERIENCE: 'none',
  CRM_EXPERIENCE: 'has_used_crm',
  HUBSPOT_EXPERIENCE: 'has_used_hubspot'
};
export const onboardingSettingsHubMap = {
  MARKETING: ONBOARDING_VIEWS.MARKETING,
  SALES: ONBOARDING_VIEWS.SALES,
  SERVICE: ONBOARDING_VIEWS.SERVICE
};